(() => {
  "use strict";

  const successTimers = new WeakMap();
  let lastSubmittedProductForm = null;
  let lastTriggeredAddButton = null;
  let lastProductHandle = null;

  const rememberProductContext = (button, form) => {
    const productForm = form || button?.closest("form[data-product-form]");
    const productRoot = button?.closest("[data-product-handle]");
    lastProductHandle =
      productForm?.dataset.productHandle ||
      productRoot?.dataset.productHandle ||
      lastProductHandle;
  };

  const collectCurrentButtons = (form, trigger, productHandle) => {
    const buttons = new Set();

    if (form && document.contains(form)) {
      form
        .querySelectorAll("[data-add-to-cart]")
        .forEach((button) => buttons.add(button));
    }

    if (trigger && document.contains(trigger)) buttons.add(trigger);

    if (productHandle) {
      document
        .querySelectorAll("form[data-product-form][data-product-handle]")
        .forEach((currentForm) => {
          if (currentForm.dataset.productHandle !== productHandle) return;
          currentForm
            .querySelectorAll("[data-add-to-cart]")
            .forEach((button) => buttons.add(button));
        });
    }

    return buttons;
  };

  const showSuccess = (button, localizedSuccessText) => {
    const label = button.querySelector("[data-add-to-cart-text]");
    if (!label) return;

    const originalText =
      button.dataset.haOriginalText || label.textContent.trim();
    const successText =
      button.dataset.langAdded || localizedSuccessText;

    button.dataset.haOriginalText = originalText;
    button.classList.add("ha-item-added");
    button.setAttribute("aria-label", successText);
    label.textContent = `${successText} ✓`;

    const currentTimer = successTimers.get(button);
    if (currentTimer) window.clearTimeout(currentTimer);

    const timer = window.setTimeout(() => {
      button.classList.remove("ha-item-added");
      button.setAttribute("aria-label", originalText);
      label.textContent = originalText;
      successTimers.delete(button);
    }, 1800);

    successTimers.set(button, timer);
  };

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest("[data-add-to-cart]");
      if (!button) return;
      lastTriggeredAddButton = button;
      rememberProductContext(button);
    },
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target.closest("[data-product-form]");
      if (!form) return;
      lastSubmittedProductForm = form;
      rememberProductContext(form.querySelector("[data-add-to-cart]"), form);
    },
    true
  );

  document.addEventListener("cart:item-added", () => {
    const form = lastSubmittedProductForm;
    const trigger = lastTriggeredAddButton;
    const productHandle = lastProductHandle;

    lastSubmittedProductForm = null;
    lastTriggeredAddButton = null;
    lastProductHandle = null;

    const localizedSuccessText =
      trigger?.dataset.langAdded ||
      form?.querySelector("[data-add-to-cart][data-lang-added]")?.dataset.langAdded ||
      document.querySelector("[data-add-to-cart][data-lang-added]")?.dataset.langAdded ||
      "Added to cart";

    const applySuccessState = () => {
      collectCurrentButtons(form, trigger, productHandle).forEach((button) => {
        showSuccess(button, localizedSuccessText);
      });
    };

    applySuccessState();
    window.setTimeout(applySuccessState, 100);
    window.setTimeout(applySuccessState, 350);
    window.setTimeout(applySuccessState, 900);
  });
})();